import { ActivityHistoryQuery } from './ActivityHistory.query';

const ActivityHistory = () => {
  return <ActivityHistoryQuery />;
};

export { ActivityHistory };
